//@ts-ignore
import { shallowCopyObjectTo } from "@utils/ObjectUtils";
export var formatCurrency = function formatCurrency(numberToFormat, options) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "it-IT";
  if (numberToFormat === undefined) return "0";
  var _options = {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0
  };
  shallowCopyObjectTo(options, _options);
  return new Intl.NumberFormat("it-IT", _options).format(numberToFormat);
};